export default __webpack_public_path__ + "static/media/linkedin.a5e8eb37.svg";